import ProductionPlannerPage from '../components/production/ProductionPlannerPage';

export default function ManagerProduction() {
  return (
    <ProductionPlannerPage
      title="Production Planner"
      subtitle="Add one or many recipes with planned quantities and download the combined picklist as Excel or PDF."
      testIdPrefix="manager-production"
    />
  );
}
